import { T, tProvide, tConsume, useT } from './context';
import PageRoute from './route';
import getLangPart from './getLangPart';
import getTemplate from './template';

export { T, tProvide, tConsume, useT, PageRoute, getLangPart, getTemplate };
